import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import Fade from "@mui/material/Fade";
import { Tooltip } from "@mui/material";

import { useState, useEffect, useRef } from "react";

import { http_post } from "./Auth";

import languageEncoding from "detect-file-encoding-and-language";

import * as u from "./utility";

function escapeHtml(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function codeStyle(fontSize) {
  return {
    ml: 0,
    mr: 0,
    mt: 0.1,
    mb: 0.1,
    pt: 0.1,
    pb: 0.1,
    pr: 1,
    pl: 1,
    background: "#505050",
    color: "#d5d5d5",
    fontSize: (11 * fontSize) / 13,
    borderRadius: "5px",
    position: "relative",
    display: "inline-block",
    width: "100%",
  };
}

export function TextPreview({
  data,
  file,
  item,
  onError,
  disableControls,
  fontSize,
}) {
  const [textData, setTextData] = useState(null);
  const [maxHeight, setMaxHeight] = useState(
    item ? u.getUiProp(item, "height", file.index, 300) : 300
  );
  const [anchor, setAnchor] = useState(null);
  const ref = useRef({ url: null, prevClick: 0 });
  const minHeight = 40;

  const decodeData = async () => {
    let buffer = null;
    let encoding = null;

    buffer = data;
    encoding = (await languageEncoding(new Blob([data.buffer]))).encoding;

    if (buffer && encoding) {
      try {
        let decoder = new TextDecoder(encoding);
        const decoded = decoder.decode(buffer);
        setTextData(decoded);
      } catch (e) {
        if (onError) {
          onError();
        }
      }
    }
  };

  useEffect(() => {
    decodeData();
  }, []);

  const [hover, setHover] = useState(false);

  const handleMouseEnter = () => {
    if (disableControls) {
      return;
    }

    setHover(true);
  };

  const handleMouseLeave = () => {
    if (disableControls) {
      return;
    }

    setHover(false);
    setAnchor(null);
  };

  const handleResize = (e) => {
    if (disableControls) {
      return;
    }

    e.preventDefault();
    let start = e.pageY;

    function onMouseMove(e) {
      setMaxHeight((prev) => {
        const newHeight = prev - start + e.pageY;
        if (newHeight > minHeight) {
          start = e.pageY;
          return newHeight;
        }
        return prev;
      });
    }
    function onMouseUp(e) {
      document.body.removeEventListener("mousemove", onMouseMove);
      document.body.removeEventListener("mouseup", onMouseUp);

      const request = async (props) => {
        try {
          let props = {
            setmessageprops: {
              PK: item.PK,
              SK: item.SK,
            },
          };
          setMaxHeight((prev) => {
            props.setmessageprops[`st_ui/height/${file.index}`] = prev;
            http_post("label", props);
            return prev;
          });
        } catch (err) {}
      };

      if (item) {
        request();
      }
    }

    document.body.addEventListener("mousemove", onMouseMove);
    document.body.addEventListener("mouseup", onMouseUp);
  };

  const handleDownload = (e) => {
    var link = document.createElement("a");
    link.href = `data:{file.mimetype},` + encodeURIComponent(textData);
    link.download = file.name;
    link.click();
  };

  const handleClick = (e) => {
    const sinceLastClick =
      e.timeStamp - (ref.current.prevClick ? ref.current.prevClick : 0);

    ref.current.prevClick = e.timeStamp;

    if (e.detail === 2 && sinceLastClick < 200) {
      // const download = async () => {
      //   if (file.url) {
      //     const path =
      //       "slackfile?url=" +
      //       encodeURIComponent(file.url) +
      //       "&filename=" +
      //       encodeURIComponent(file.name);

      //     const response = await http_post(path, null);
      //     window.open(response.data.url, "_blank", "noreferrer");
      //   }
      // };
      // download();
      const data = "data:text/plain;charset=utf-8,hello";
      var wnd = window.open("", "_blank");
      wnd.document.open();
      wnd.document.write(`<pre>${escapeHtml(textData)}</pre>`);
      wnd.document.close();

      e.stopPropagation();
    }
  };

  return (
    <Box
      component="span"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{ width: "100%" }}
    >
      <Box
        sx={{ position: "relative", display: "inline-block", width: "100%" }}
      >
        {hover && (
          <>
            <Box sx={{ position: "absolute", right: 10, top: 6, zIndex: 5 }}>
              <Stack direction="row" gap={0}>
                <Tooltip title={`Download ${file.name}`}>
                  <IconButton size="small" onClick={handleDownload}>
                    <DownloadIcon fontSize="inherit" sx={{ color: "white" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Copy to clipboard">
                  <IconButton
                    size="small"
                    variant="contained"
                    onClick={(e) => {
                      navigator.clipboard.writeText(textData);
                      setAnchor(e.currentTarget);
                      setTimeout(() => {
                        setAnchor(null);
                      }, 1000);
                    }}
                  >
                    <ContentCopyIcon
                      size="small"
                      fontSize="inherit"
                      sx={{ color: "white" }}
                    />
                  </IconButton>
                </Tooltip>
              </Stack>
              <Popper
                open={anchor != null}
                anchorEl={anchor}
                placement="right-start"
                transition
              >
                {({ TransitionProps }) => (
                  <Fade {...TransitionProps} timeout={350}>
                    <Paper>
                      <Typography fontSize={10} sx={{ p: 1 }}>
                        copied!
                      </Typography>
                    </Paper>
                  </Fade>
                )}
              </Popper>
            </Box>

            <Box
              sx={{
                position: "absolute",
                bottom: 2,
                zIndex: 10,
                cursor: "ns-resize",
                height: 14,
                width: "100%",
                backgroundColor: "black",
                opacity: "30%",
                cursor: "row-resize",
              }}
              onMouseDown={handleResize}
            ></Box>
          </>
        )}

        <Box
          sx={{
            ...codeStyle(fontSize),
            maxHeight: maxHeight,
            minHeight: minHeight,
            minHeight: 25,
            overflow: "auto",
          }}
          onClick={handleClick}
        >
          <Stack direction={"row"}>
            <pre
              style={{
                width: "100%",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {textData}
            </pre>
            <Box sx={{ width: "50px" }}></Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
